<template>
    <page :showBackButton="true">
        <!-- 
    Übersicht
    <template v-for="(value, key) in $store.state.contracts[contractId]">
      <div :key="key+'1'">{{key}}: {{value}}</div>
    </template>

    Details
    <template v-for="(value, key) in contractDetails">
      <div :key="key+'2'">{{key}}: {{value}}</div>
    </template> -->

        <!-- <template v-slot:header>
      <ion-title>
        <ion-label>Vertragsübersicht</ion-label>
      </ion-title>
    </template> -->

        <contract-card :contractId="contractId"></contract-card>
        <!-- <h2 v-if="contractId in $store.state.contracts">
            Sparte: {{ $store.state.contracts[this.contractId].Sparte }}
        </h2> -->
        <ion-segment
            @ionChange="segmentChanged($event)"
            class="ion-padding-bottom"
            :value="selectedSegment"
        >
            <ion-segment-button value="vertrag" checked>
                <ion-label>Vertrag</ion-label>
            </ion-segment-button>
            <ion-segment-button value="person">
                <ion-label>Kundeninfos</ion-label>
            </ion-segment-button>
            <ion-segment-button value="zahlung">
                <ion-label>Zahlung</ion-label>
            </ion-segment-button>
        </ion-segment>

        <div
            v-show="
                selectedSegment === 'vertrag' &&
                Object.keys(contractDetails).length > 0
            "
        >
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>Vertragsübersicht</ion-list-header>
                    <!-- <template v-for="(value, key) in $store.state.contracts[contractId]"> -->
                    <template v-for="(value, key) in contractDetails">
                        <ion-item
                            :key="key"
                            v-if="allgemeinConfig[key] != undefined"
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    allgemeinConfig[key]['label'] ||
                                    allgemeinConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            allgemeinConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                </ion-list>
            </ion-card>
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Vertragsdetails</ion-label>
                    </ion-list-header>
                    <template v-for="(value, key) in contractDetails">
                        <ion-item
                            :key="key"
                            v-if="
                                produktConfig[key] != undefined &&
                                checkStatus(key)
                            "
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    produktConfig[key]['label'] ||
                                    produktConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            produktConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                </ion-list>
            </ion-card>

            <template
                v-if="
                    $store.state.contracts[contractId] &&
                    ('FlexibleLife' in
                        $store.state.contracts[contractId]['Features'] ||
                        'Vollwert' in
                            $store.state.contracts[contractId]['Features'])
                "
            >
                <!-- || 'Vollwert' in $store.state.contracts[contractId]['Features']" -->
                <ion-button
                    expand="block"
                    @click="
                        $router.push({
                            name: 'uebersicht',
                            params: { motive: motive, contractId: contractId },
                        })
                    "
                    >Alle Fonds Details</ion-button
                >
            </template>
        </div>

        <div v-show="selectedSegment === 'person'">
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>
                        <ion-label>{{
                            personConfig["mainHeadline"]
                        }}</ion-label>
                    </ion-list-header>
                    <template
                        v-for="(value, key) in contractDetails['CustomerData']"
                    >
                        <ion-item
                            :key="key"
                            v-if="personConfig[key] != undefined"
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    personConfig[key]['label'] ||
                                    personConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            personConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                    <template v-if="!contractDetails.CustomerData">
                        <template
                            v-for="(value, key) in contractDetails[
                                'CustomerAlternativeData1'
                            ]"
                        >
                            <ion-item
                                :key="'CustomerAlternativeData1-' + key"
                                v-if="personConfig[key] != undefined"
                            >
                                <ion-label
                                    class="ion-text-wrap"
                                    v-html="
                                        personConfig[key]['label'] ||
                                        personConfig[key]
                                    "
                                ></ion-label>
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b
                                        v-html="
                                            getFormattedValue(
                                                personConfig[key],
                                                value
                                            )
                                        "
                                    ></b>
                                </ion-label>
                            </ion-item>
                        </template>
                        <div
                            :class="{
                                'ion-margin-top':
                                    contractDetails.CustomerAlternativeData1,
                            }"
                        >
                            <template
                                v-for="(value, key) in contractDetails[
                                    'CustomerAlternativeData2'
                                ]"
                            >
                                <ion-item
                                    v-if="personConfig[key] != undefined"
                                    :key="'CustomerAlternativeData2-' + key"
                                >
                                    <ion-label
                                        class="ion-text-wrap"
                                        v-html="
                                            personConfig[key]['label'] ||
                                            personConfig[key]
                                        "
                                    ></ion-label>
                                    <ion-label
                                        class="ion-text-wrap ion-text-right"
                                        ><b
                                            v-html="
                                                getFormattedValue(
                                                    personConfig[key],
                                                    value
                                                )
                                            "
                                        ></b>
                                    </ion-label>
                                </ion-item>
                            </template>
                        </div>
                    </template>
                </ion-list>
            </ion-card>

            <ion-card class="-light" v-if="'Customer2Data' in contractDetails">
                <ion-list>
                    <ion-list-header>
                        <ion-label
                            >{{ personConfig["mainHeadline"] }} 2</ion-label
                        >
                    </ion-list-header>
                    <template
                        v-for="(value, key) in contractDetails['Customer2Data']"
                    >
                        <ion-item
                            :key="key"
                            v-if="personConfig[key] != undefined"
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    personConfig[key]['label'] ||
                                    personConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            personConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                </ion-list>
            </ion-card>

            <ion-card class="-light" v-if="'CustomerGVData' in contractDetails">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Gesetzlicher Vertreter</ion-label>
                    </ion-list-header>
                    <ion-item>
                        <ion-label class="ion-text-wrap">Vorname</ion-label>
                        <ion-label class="ion-text-wrap ion-text-right"
                            ><b>{{ contractDetails.CustomerGVData.vorname }}</b>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-label class="ion-text-wrap">Nachname</ion-label>
                        <ion-label class="ion-text-wrap ion-text-right"
                            ><b>{{
                                contractDetails.CustomerGVData.nachname
                            }}</b>
                        </ion-label>
                    </ion-item>
                    <ion-item>
                        <ion-label class="ion-text-wrap"
                            >Geburtsdatum</ion-label
                        >
                        <ion-label class="ion-text-wrap ion-text-right"
                            ><b>{{
                                contractDetails.CustomerGVData.geburtstag
                            }}</b>
                        </ion-label>
                    </ion-item>
                </ion-list>
            </ion-card>

            <template v-for="index in 5">
                <ion-card
                    class="-light"
                    :key="'CustomerExtraId-' + index"
                    v-if="'CustomerExtraId' + index in contractDetails"
                >
                    <ion-list>
                        <ion-list-header>
                            <ion-label
                                >{{ personConfig["secondHeadline"] }}
                                {{ index }}</ion-label
                            >
                        </ion-list-header>
                        <template
                            v-for="(value, key) in contractDetails[
                                'CustomerExtraData' + index
                            ]"
                        >
                            <ion-item
                                :key="key"
                                v-if="personConfig[key] != undefined"
                            >
                                <ion-label
                                    class="ion-text-wrap"
                                    v-html="
                                        personConfig[key]['label'] ||
                                        personConfig[key]
                                    "
                                ></ion-label>
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b
                                        v-html="
                                            getFormattedValue(
                                                personConfig[key],
                                                value
                                            )
                                        "
                                    ></b>
                                </ion-label>
                            </ion-item>
                        </template>
                    </ion-list>
                </ion-card>
            </template>

            <template v-for="index in 5">
                <ion-card
                    class="-light"
                    :key="'CustomerChildId-' + index"
                    v-if="'CustomerChildId' + index in contractDetails"
                >
                    <ion-list>
                        <ion-list-header>
                            <ion-label
                                >{{ personConfig["thirdHeadline"] }}
                                {{ index }}</ion-label
                            >
                        </ion-list-header>
                        <template
                            v-for="(value, key) in contractDetails[
                                'CustomerChildData' + index
                            ]"
                        >
                            <ion-item
                                :key="key"
                                v-if="personConfig[key] != undefined"
                            >
                                <ion-label
                                    class="ion-text-wrap"
                                    v-html="
                                        personConfig[key]['label'] ||
                                        personConfig[key]
                                    "
                                ></ion-label>
                                <ion-label class="ion-text-wrap ion-text-right"
                                    ><b
                                        v-html="
                                            getFormattedValue(
                                                personConfig[key],
                                                value
                                            )
                                        "
                                    ></b>
                                </ion-label>
                            </ion-item>
                        </template>
                    </ion-list>
                </ion-card>
            </template>

            <ion-card
                class="-light"
                v-if="'CustomerPaymentData' in contractDetails"
            >
                <ion-list>
                    <ion-list-header>
                        <ion-label>Beitragszahler</ion-label>
                    </ion-list-header>
                    <template
                        v-for="(value, key) in contractDetails[
                            'CustomerPaymentData'
                        ]"
                    >
                        <ion-item
                            :key="key"
                            v-if="personConfig[key] != undefined"
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    personConfig[key]['label'] ||
                                    personConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            personConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                </ion-list>
            </ion-card>
        </div>

        <div v-show="selectedSegment === 'zahlung'">
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Zahlungsinformationen</ion-label>
                    </ion-list-header>
                    <template v-for="(value, key) in contractDetails">
                        <ion-item
                            :key="key"
                            v-if="
                                key !== 'FromDate' &&
                                zahlungConfig[key] != undefined
                            "
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    zahlungConfig[key]['label'] ||
                                    zahlungConfig[key]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            zahlungConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                        <!-- {{key}} -->
                    </template>
                </ion-list>
            </ion-card>

            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Bankdaten</ion-label>
                        <ion-button
                            fill="clear"
                            color="dark"
                            class=""
                            @click="showInfo('Bankdaten')"
                            size="small"
                            v-if="!contractDetails['BankAccountData']"
                        >
                            <ion-icon
                                name="information-circle-outline"
                                slot="icon-only"
                            ></ion-icon
                        ></ion-button>
                    </ion-list-header>
                    <template
                        v-for="(value, key) in contractDetails[
                            'BankAccountData'
                        ]"
                    >
                        <ion-item
                            :key="key"
                            v-if="zahlungConfig[key] != undefined"
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    zahlungConfig[key]['label'] ||
                                    zahlungConfig[key]
                                "
                            ></ion-label>

                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            zahlungConfig[key],
                                            value
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                        <!-- {{key}} -->
                    </template>
                </ion-list>
            </ion-card>

            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>
                        <ion-label>Kontoinhaber</ion-label>
                    </ion-list-header>
                    <template
                        v-for="(customerPaymentDatavalue,
                        customerPaymentDataKey) in contractDetails[
                            'CustomerPaymentData'
                        ]"
                    >
                        <ion-item
                            :key="customerPaymentDataKey"
                            v-if="
                                zahlungConfig[customerPaymentDataKey] !=
                                undefined
                            "
                        >
                            <ion-label
                                class="ion-text-wrap"
                                v-html="
                                    zahlungConfig[customerPaymentDataKey][
                                        'label'
                                    ] || zahlungConfig[customerPaymentDataKey]
                                "
                            ></ion-label>
                            <ion-label class="ion-text-wrap ion-text-right"
                                ><b
                                    v-html="
                                        getFormattedValue(
                                            zahlungConfig[
                                                customerPaymentDataKey
                                            ],
                                            customerPaymentDatavalue
                                        )
                                    "
                                ></b>
                            </ion-label>
                        </ion-item>
                    </template>
                </ion-list>
            </ion-card>
            <ion-button
                expand="block"
                @click="
                    $router.push({
                        name: 'umsaetze',
                        params: { motive: motive, contractId: contractId },
                    })
                "
                >Alle Ein-/Auszahlungen anzeigen</ion-button
            >
        </div>
    </page>
</template>

<script>
import Page from "@/components/Page";
import ContractCard from "@/components/ContractCard";
import InfoModal from "@/components/InfoModal";

export default {
    components: { Page, ContractCard },
    props: ["contractId", "motive"],
    data() {
        return {
            selectedSegment: "vertrag",
        };
    },
    mounted() {
        this.$store.cache.dispatch(
            "contractsDetails/getContractDetails",
            this.contractId
        );
    },
    methods: {
        checkStatus(key) {
            if (
                !this.produktConfig[key].checkStatus ||
                !this.contractDetails[key.substring(0, key.length - 7)] ||
                this.contractDetails[key.substring(0, key.length - 7)] ===
                    "aufrecht"
            ) {
                return true;
            } else {
                return false;
            }
        },
        showInfo(id) {
            this.$ionic.modalController
                .create({
                    component: InfoModal,
                    cssClass: "c-info-modal",
                    componentProps: {
                        propsData: {
                            id: id,
                            contractId: this.contractId,
                            motive: this.motive,
                        },
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
        segmentChanged(e) {
            this.selectedSegment = e.detail.value;
        },
        getFormattedValue(currentConfig, value) {
            var formattedValue = "";
            if (currentConfig["type"] == "date") {
                formattedValue = this.getFormattedDate(value);
            } else if (currentConfig["type"] == "currency") {
                formattedValue = this.$options.filters.currency(value);
            } else if (currentConfig["type"] == "replace") {
                // console.log(currentConfig.replace[value]);
                // console.log(currentConfig.replace[value]);
                // console.log(value);
                formattedValue = currentConfig.replace[value];
            } else if (currentConfig["type"] == "iban") {
                formattedValue = "xxxxxxxxxxxxxx";

                formattedValue = value
                    .replace(/(\w{4})/g, "$1 ")
                    .replace(/(^\s+|\s+$)/, "");
            } else {
                formattedValue = value;
            }

            return formattedValue;
        },
        getFormattedDate(date) {
            // var tempDate = new Date("2016-10-01+02:00");

            var tempDate = date.substring(0, date.indexOf("+")).split("-");

            // console.log(tempDate);
            // var formatteddate =         tempDate.getDate() + "." + (tempDate.getMonth() + 1) + "." + tempDate.getFullYear(); //prints expected format.
            var formatteddate =
                tempDate[2] + "." + tempDate[1] + "." + tempDate[0]; //prints expected format.

            return formatteddate;
        },
    },
    computed: {
        contractDetails() {
            let result = {};
            if (this.contractId in this.$store.state.contractsDetails.all) {
                result = this.$store.state.contractsDetails.all[
                    this.contractId
                ];
            }
            return result;
        },

        zahlungConfig() {
            let result = {};
            if (this.contractId in this.$store.state.contracts) {
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].zahlung;
            }
            return result;
        },
        personConfig() {
            let result = {};
            if (this.contractId in this.$store.state.contracts) {
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].person;
            }
            return result;
        },

        allgemeinConfig() {
            let result = {};
            // if (this.contractId in this.$store.state.contractsDetails.all) {
            if (this.contractId in this.$store.state.contracts) {
                // console.log(this.$store.state.contracts[this.contractId]);
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].allgemein;
            }

            // console.log(contractsConfig[this.title]["label"]);
            // if (contractsConfig[this.title] != undefined) {
            //   if (contractsConfig[this.title]["label"] != undefined) {
            //     return contractsConfig[this.title]["label"];
            //   }
            // }
            return result;
        },
        produktConfig() {
            let result = {};
            if (this.contractId in this.$store.state.contractsDetails.all) {
                // console.log(this.$store.state.contracts[this.contractId]);
                result = this.$store.state.contractsConfig[
                    this.$store.state.contracts[this.contractId].Sparte
                ].produkt;
            }
            // let produktConfig = this.$store.state.contractsConfig.[this.$store.state.contractsDetails.all[this.contractId].Sparte].produktConfig;

            // console.log(contractsConfig[this.title]["label"]);
            // if (contractsConfig[this.title] != undefined) {
            //   if (contractsConfig[this.title]["label"] != undefined) {
            //     return contractsConfig[this.title]["label"];
            //   }
            // }
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
ion-list ion-label {
    flex: unset;
    flex-grow: 1;
}
</style>
